import Axios from "./Axios";
import API_URL from "./URLS";

export const LOGIN_ADMIN = (data) => Axios.post(API_URL.LOGIN_ADMIN, data);
export const FORGET_PASSWORD_ADMIN = (data) =>
  Axios.post(API_URL.FORGET_PASSWORD_ADMIN, data);
export const RESET_PASSWORD = (data) =>
  Axios.post(API_URL.RESET_PASSWORD, data);
export const CHANGE_PASSWORD = (data) =>
  Axios.post(API_URL.CHANGE_PASSWORD, data);
export const GET_PROFILE = (data) => Axios.get(API_URL.GET_PROFILE);
export const UPDATE_PROFILE = (data) =>
  Axios.post(API_URL.UPDATE_PROFILE, data);

// upload file
export const UPLOAD_FILE = (data) => Axios.post(API_URL.UPLOAD_FILE, data);

// dashboard

export const DASHBOARD_DATA = (data) => Axios.get(API_URL.DASHBOARD_DATA);

// help

export const HELP_LIST = (data) => Axios.post(API_URL.HELP_LIST, data);

// accounting

export const ACCOUNTING_LIST = (data) => Axios.post(API_URL.ACCOUNTING_LIST);

// user
export const ADD_USER = (data) => Axios.post(API_URL.ADD_USER, data);
export const USER_LIST = (data) => Axios.post(API_URL.USER_LIST, data);
export const GET_USER_BY_ID = (data) =>
  Axios.get(API_URL.GET_USER_BY_ID + data);
export const UPDATE_USER = (data) => Axios.post(API_URL.UPDATE_USER, data);
export const DELETE_USER = (data) => Axios.post(API_URL.DELETE_USER, data);
export const USER_STATUS_CHANGE = (data) =>
  Axios.post(API_URL.USER_STATUS_CHANGE, data);
export const USER_IMPORT_BY_CSV = (data) =>
  Axios.post(API_URL.USER_IMPORT_BY_CSV, data);
export const EXPORT_USER_CSV = (data) =>
  Axios.get(API_URL.EXPORT_USER_CSV, data);

// service provider
export const SERVICE_PROVIDERS_LIST = (data) =>
  Axios.post(`${API_URL.SERVICE_PROVIDERS_LIST}?type=${data.type}`, data);
export const SERVICE_PROVIDER_VIEW = (data) =>
  Axios.get(API_URL.SERVICE_PROVIDER_VIEW + data);
export const ADD_SERVICE_PROVIDER = (data) =>
  Axios.post(API_URL.ADD_SERVICE_PROVIDER, data);
export const DELETE_PROVIDER = (data) =>
  Axios.post(API_URL.DELETE_PROVIDER, data);
export const UPDATE_SERVICE_PROVIDER = (data) =>
  Axios.post(API_URL.UPDATE_SERVICE_PROVIDER, data);
export const STATUS_CHANGE_SERVICE_PROVIDER = (data) =>
  Axios.post(API_URL.STATUS_CHANGE_SERVICE_PROVIDER, data);
export const SERVICE_PROVIDER_IMPORT_BY_CSV = (data) =>
  Axios.post(API_URL.SERVICE_PROVIDER_IMPORT_BY_CSV, data);
export const EXPORT_SERVICE_PROVIDER_CSV = (data) =>
  Axios.get(API_URL.EXPORT_SERVICE_PROVIDER_CSV, data);
export const EXPORT_REPORTED_CSV = (data) =>
  Axios.post(API_URL.EXPORT_REPORTED_CSV, data);
// earning report
export const GET_EARNING_REPORT = (data) =>
  Axios.post(API_URL.GET_EARNING_REPORT, data);
// SERVICE CATEGORY

export const SERVICE_CATEGORY_LIST = (data) =>
  Axios.post(API_URL.SERVICE_CATEGORY_LIST, data);
export const ADD_SERVICE_CATEGORY = (data) =>
  Axios.post(API_URL.ADD_SERVICE_CATEGORY, data);
export const UPDATE_SERVICE_CATEGORY = (data) =>
  Axios.post(API_URL.UPDATE_SERVICE_CATEGORY, data);
export const DELETE_SERVICE_CATEGORY = (data) =>
  Axios.post(API_URL.DELETE_SERVICE_CATEGORY, data);
export const VIEW_SERVICE_CATEGORY = (data) =>
  Axios.get(API_URL.VIEW_SERVICE_CATEGORY + data);
// SIGNUP Question
export const SIGNUPQUESTIONLIST = (data) =>
  Axios.post(API_URL.SIGNUP_QUESTION_LIST, data);
export const SIGNUPQUESTIONADD = (data) =>
  Axios.post(API_URL.SIGNUP_QUESTION_ADD, data);
export const SIGNUPQUESTIONUPDATE = (data) =>
  Axios.post(API_URL.SIGNUP_QUESTION_UPDATE, data);
export const SIGNUPQUESTIONDELETE = (data) =>
  Axios.post(API_URL.SIGNUP_QUESTION_DELETE, data);
export const SIGNUPQUESTIONDETAIL = (data) =>
  Axios.get(API_URL.SIGNUPQUESTION_DETAIL + data);
// Category Request list
export const CATEGORYREQUESTLIST = (data) =>
  Axios.post(API_URL.CATEGORY_REQUEST_LIST, data);
export const GETVENDORTHERAPIST = (data) =>
  Axios.post(API_URL.GET_VENDORTHRAPIST, data);
export const ACCEPTCATEGORY = (data) =>
  Axios.post(API_URL.ACCEPT_CATEGORY_REQUEST, data);
export const REASSIGNCATEGORY = (data) =>
  Axios.post(API_URL.REASSIGN_CATEGORY_REQUEST, data);
export const REJECTCATEGORY = (data) =>
  Axios.post(API_URL.REJECT_CATEGORY_REQUEST, data);

// subscription ----->
export const SUBSCRIPTION_LIST = (data) =>
  Axios.post(API_URL.GET_SUBSCRIPTION, data);

export const SUBSCRIPTION_ADD = (data) =>
  Axios.post(API_URL.ADD_SUBSCRIPTION, data);
export const SUBSCRIPTION_EDIT = (data) =>
  Axios.post(API_URL.EDIT_SUBSCRIPTION, data);
export const SUBSCRIPTION_DELETE = (id) =>
  Axios.get(API_URL.DELETE_SUBSCRIPTION + id);
export const SUBSCRIPTION_DETAIL = (data) =>
  Axios.get(API_URL.VIEW_SUBSCRIPTION + data);
export const SUBSCRIPTION_SUBSCRIBER = (data) =>
  Axios.get(`${API_URL.GET_SUBSCRIPTION_SUBSCRIBER}${makeParams(data)}`);
// content
export const ADD_CONTENT = (data) => Axios.post(API_URL.ADD_CONTENT, data);
export const CONTENT_VIEW = (data) => Axios.get(API_URL.CONTENT_VIEW + data);
export const CONTENT_UPDATE = (data) =>
  Axios.post(API_URL.CONTENT_UPDATE, data);
export const CONTENT_STATUS_CHANGE = (data) =>
  Axios.post(API_URL.CONTENT_STATUS_CHANGE, data);
export const CONTENT_DELETE = (data) =>
  Axios.post(API_URL.CONTENT_DELETE, data);
export const CONTENT_LIST = (data) => Axios.post(API_URL.CONTENT_LIST, data);

// faq

export const ADD_FAQ = (data) => Axios.post(API_URL.ADD_FAQ, data);
export const FAQ_VIEW = (id) => Axios.get(API_URL.FAQ_VIEW + id);
export const UPDATE_FAQ = (data) => Axios.post(API_URL.FAQ_UPDATE, data);
export const CHANGE_FAQ_STATUS = (data) =>
  Axios.post(API_URL.FAQ_STATUS_CHANGE, data);
export const DELETE_FAQ = (id) => Axios.post(API_URL.FAQ_DELETE, id);
export const LIST_FAQS = (data) => Axios.post(API_URL.FAQ_LIST, data);
// Manage Promocode

export const ADD_PROMOCODE = (data) => Axios.post(API_URL.ADD_PROMOCODE, data);
export const UPDATE_PROMOCODE = (data) =>
  Axios.post(API_URL.UPDATE_PROMOCODE, data);
export const PROMOCODE_LIST = (data) =>
  Axios.post(API_URL.PROMOCODE_LIST, data);
export const DELETE_PROMOCODE = (data) =>
  Axios.post(API_URL.DELETE_PROMOCODE, data);
export const GET_PROMOCODE_BY_ID = (data) =>
  Axios.get(API_URL.GET_PROMOCODE_BY_ID + data);
export const PROMOCODE_STATUS_CHANGE = (data) =>
  Axios.post(API_URL.PROMOCODE_STATUS_CHANGE, data);

//manage report
export const ADDREPORT = (data) => Axios.post(API_URL.ADD_REPORT, data);
export const UPDATEREPORT = (data) => Axios.post(API_URL.UPDATE_REPORT, data);
export const REPORTLIST = (data) => Axios.post(API_URL.REPORT_LIST, data);
export const DELETEREPORT = (data) => Axios.post(API_URL.DELETE_REPORT, data);
export const GETREPORTBYID = (data) =>
  Axios.post(API_URL.GET_REPORT_BY_ID, data);

export const ADD_SUB_ADMIN = (data) => Axios.post(API_URL.ADD_SUB_ADMIN, data);
export const UPDATE_SUB_ADMIN = (data) =>
  Axios.post(API_URL.UPDATE_SUB_ADMIN, data);
export const SUBADMINS_LIST = (data) =>
  Axios.post(API_URL.SUBADMINS_LIST, data);
export const DELETE_SUBADMIN = (data) =>
  Axios.post(API_URL.DELETE_SUBADMIN, data);
export const GET_SUBADMIN_BY_ID = (data) =>
  Axios.get(API_URL.GET_SUBADMIN_BY_ID + data);
export const UPDATE_SYSTEM_ACCESS_STATUS = (data) =>
  Axios.post(API_URL.UPDATE_SYSTEM_ACCESS_STATUS, data);

// Manage Commision
export const COMMISSIONS_LIST = (data) =>
  Axios.post(API_URL.COMMISSIONS_LIST, data);
export const DELETE_COMMISSION = (data) =>
  Axios.post(API_URL.DELETE_COMMISSION, data);
export const SET_COMMISSION = (data) =>
  Axios.post(API_URL.SET_COMMISSION, data);
// export const COMMISSIONS_LIST = () =>  Axios.post(API_URL.COMMISSIONS_LIST, data);
// export const DELETE_COMMISSION = () =>  Axios.post(API_URL.DELETE_COMMISSION, data);

// Order Management
export const GET_ORDER = (data) => Axios.post(API_URL.GET_ORDER, data);
export const GET_REPORTED_USERS = (data) => Axios.post(API_URL.GET_REPORTED_USERS, data);
export const VIEW_ORDER = (data) => Axios.get(API_URL.VIEW_ORDER + data);
export const UPDATE_DISPUTE = (data) =>
  Axios.post(API_URL.UPDATE_DISPUTE, data);
export const UPDATE_DOCUMENT = (data) =>
  Axios.post(API_URL.DOCUMENT_STATUS, data);

export const ADD_PROMOTION = (data) => Axios.post(API_URL.ADD_PROMOTION, data);
export const UPDATE_PROMOTION = (data) =>
  Axios.post(API_URL.UPDATE_PROMOTION, data);
export const PROMOTION_LIST = (data) =>
  Axios.post(API_URL.PROMOTION_LIST, data);
export const DELETE_PROMOTION = (data) =>
  Axios.post(API_URL.DELETE_PROMOTION, data);
export const GET_PROMOTION_BY_ID = (data) =>
  Axios.get(API_URL.GET_PROMOTION_BY_ID + data);

export const BASIC_CONFIG_DATA = () => Axios.get(API_URL.CONFIG_DATA);
export const GET_BASIC_SETTING = () => Axios.get(API_URL.BASIC_SETTING);
export const UPDATE_BASIC_SETTING = (data) =>
  Axios.post(API_URL.UPDATE_BASIC_SETTING, data);

// notification

export const ADD_NOTIFICATION = (data) =>
  Axios.post(API_URL.ADD_NOTIFICATION, data);
export const NOTIFICATION_VIEW = (id) =>
  Axios.get(API_URL.NOTIFICATION_VIEW + id);
export const UPDATE_NOTIFICATION = (data) =>
  Axios.post(API_URL.NOTIFICATION_UPDATE, data);
export const CHANGE_NOTIFICATION_STATUS = (data) =>
  Axios.post(API_URL.NOTIFICATION_STATUS_CHANGE, data);
export const DELETE_NOTIFICATION = (id) =>
  Axios.post(API_URL.NOTIFICATION_DELETE, id);
export const LIST_NOTIFICATIONS = (data) =>
  Axios.post(API_URL.NOTIFICATION_LIST, data);

export const REFUND_LIST = (data) => Axios.post(API_URL.REFUND_LIST, data);
export const EXPORT_HELP_CSV = (data) =>
  Axios.get(API_URL.EXPORT_HELP_CSV, data);

// SERVICE

export const SERVICE_LIST = (data) => Axios.post(API_URL.SERVICE_LIST, data);
export const ADD_SERVICE = (data) => Axios.post(API_URL.ADD_SERVICE, data);
export const UPDATE_SERVICE = (data) =>
  Axios.post(API_URL.UPDATE_SERVICE, data);
export const DELETE_SERVICE = (data) =>
  Axios.post(API_URL.DELETE_SERVICE, data);
export const VIEW_SERVICE = (data) => Axios.get(API_URL.VIEW_SERVICE + data);

// QUESTION

export const QUESTION_LIST = (data) => Axios.post(API_URL.QUESTION_LIST, data);
export const ADD_QUESTION = (data) => Axios.post(API_URL.ADD_QUESTION, data);
export const UPDATE_QUESTION = (data) =>
  Axios.post(API_URL.UPDATE_QUESTION, data);
export const DELETE_QUESTION = (data) =>
  Axios.post(API_URL.DELETE_QUESTION, data);
export const VIEW_QUESTION = (data) => Axios.get(API_URL.VIEW_QUESTION + data);
export const GET_CATEGORY_REQUEST = (data) =>
  Axios.post(API_URL.GET_CATEGORY_REQUEST, data);

